import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { GlobalMethodsService } from 'src/app/services/global-methods.service';
import { DefaultModalComponent } from '../../../default-modal/default-modal.component';
import { ModalService } from '../../../../../services/commons/modal.service';

@Component({
  selector: 'app-privacy-polity',
  templateUrl: './privacy-polity.component.html',
  styleUrls: ['./privacy-polity.component.scss'],
})
export class PrivacyPolityComponent implements OnInit {

  @Input('priva') priva: string;
  @ViewChild('iframePriva') iframePriva: ElementRef;
  constructor(private modalCtrl: ModalController,
              public gms: GlobalMethodsService,
              private defaultModalComponent: DefaultModalComponent,
              private modalService: ModalService,
              public platform: Platform) { }

  async ngOnInit() {
    this.gms.setLoadingTrue();
    await this.gms.clearIntervalStatusInstallationEvent();
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Politica Privacidad', contentGroup: 'Inicio'});
  }

  async ionViewDidEnter() {
    // let doc = this.iframePriva.nativeElement.contentDocument;
    // doc.body.innerHTML = doc.body.innerHTML + '<style>html { color: #FFFFFF; font-size: 14px; line-height: 21px; font-family: "Allumi-Regular" } a{ color: #FFFFFF } </style>';
    // let nodes: NodeListOf<HTMLAnchorElement>;
    // document.querySelectorAll('iframe').forEach( item =>
    //   nodes = item.contentWindow.document.body.querySelectorAll('a')
    // )
    // for (var i = 0; i < nodes.length; i++) {
    //   nodes[i].addEventListener('click', (event: any) => {
    //     if(event.srcElement.href.indexOf('www.') && event.srcElement.hash === ''){
    //       event.preventDefault();
    //       window.open(event.srcElement.href, '_system');
    //     }else if(event.srcElement.hash.charAt(0) === '#'){
    //       event.preventDefault();
    //     }
    //   });
    // }
    document.getElementById("legal-text").innerHTML = this.priva;

    this.gms.setLoadingFalse();
  }

  dismiss(value) {
    this.modalService.hide('privacyModal', value);
  }

}
